<template>
  <main class="supplier-api-keys-page">
    <section class="soft-card table-panel">
      <div class="toolbar">
        <el-button size="small" plain icon="el-icon-arrow-left" circle @click="goBack" style="margin-right: 4px;" />
        <el-input
          v-model="searchQuery"
          placeholder="搜索 Key 名称..."
          size="small"
          clearable
          class="search-input"
          @keyup.enter.native="onSearch" @clear="onSearch"
        />
        <el-button size="small" plain icon="el-icon-search" @click="onSearch">搜索</el-button>
        <el-button type="primary" size="small" icon="el-icon-plus" @click="onAdd">新增</el-button>
      </div>
      <div class="desktop-only">
        <el-table :data="keys" size="small" style="width: 100%">
          <el-table-column type="index" label="序号" width="60" :index="pageIndex" />
          <el-table-column prop="name" label="名称" min-width="140" />
          <el-table-column prop="apiKey" label="API Key" min-width="240">
            <template slot-scope="scope">
              <code class="key-text">{{ scope.row.apiKey }}</code>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="100">
            <template slot-scope="scope">
              <el-tag size="small" :type="scope.row.status === '启用' ? 'success' : 'info'">{{ scope.row.status }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" width="180">
            <template slot-scope="scope">{{ $formatTime(scope.row.createdAt) }}</template>
          </el-table-column>
          <el-table-column label="操作" width="160">
            <template slot-scope="scope">
              <el-button size="small" type="text" @click="onEdit(scope.row)">编辑</el-button>
              <el-button size="small" type="text" :class="{ 'delete-btn': true, 'enable-btn': scope.row.status === '已禁用' }" @click="onToggleStatus(scope.row)">
                {{ scope.row.status === '启用' ? '禁用' : '启用' }}
              </el-button>
              <el-button size="small" type="text" class="delete-btn" @click="onDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination-bar"
          layout="total, prev, pager, next"
          small
          :total="total"
          :page-size="pageSize"
          :current-page.sync="currentPage"
          @current-change="onPageChange"
        />
      </div>
      <div class="mobile-only list-cards">
        <div v-for="item in keys" :key="item.id" class="list-card">
          <div class="card-header">
            <div class="card-title">{{ item.name }}</div>
            <el-tag size="small" :type="item.status === '启用' ? 'success' : 'info'">{{ item.status }}</el-tag>
          </div>
          <div style="margin-bottom:8px;">
            <code style="font-size:12px;color:#8eddf8;background:rgba(50,200,245,.08);padding:2px 8px;border-radius:4px;word-break:break-all;">{{ item.apiKey }}</code>
          </div>
          <div class="meta-row">
            <span>{{ $formatTime(item.createdAt) }}</span>
          </div>
          <div class="card-actions">
            <el-button size="small" type="text" @click="onEdit(item)">编辑</el-button>
            <el-button size="small" type="text" :class="{ 'delete-btn': true, 'enable-btn': item.status === '已禁用' }" @click="onToggleStatus(item)">
              {{ item.status === '启用' ? '禁用' : '启用' }}
            </el-button>
            <el-button size="small" type="text" class="delete-btn" @click="onDelete(item)">删除</el-button>
          </div>
        </div>
      </div>
    </section>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px" :close-on-click-modal="false" top="25vh">
      <div style="margin-bottom:20px;font-size:13px;color:#64748b;">
        <i class="el-icon-s-platform" style="margin-right:4px;"></i>
        {{ supplierName }}
      </div>
      <el-form ref="form" :model="form" :rules="rules" label-width="0" size="small">
        <el-form-item prop="name">
          <el-input v-model="form.name" placeholder="Key 名称，例: 主 API Key" />
        </el-form-item>
        <el-form-item prop="apiKey">
          <el-input v-model="form.apiKey" placeholder="sk-xxxxxxxx">
            <template slot="prepend">API Key</template>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="submitForm" size="small" :loading="submitting">确定</el-button>
      </span>
    </el-dialog>
  </main>
</template>

<script>
export default {
  name: 'SupplierApiKeysPage',
  data() {
    return {
      keys: [],
      total: 0,
      pageSize: 10,
      currentPage: 1,
      searchQuery: '',
      dialogVisible: false,
      dialogTitle: '',
      submitting: false,
      form: {
        id: null,
        name: '',
        apiKey: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入 Key 名称', trigger: 'blur' }
        ],
        apiKey: [
          { required: true, message: '请输入 API Key', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    supplierId() {
      return this.$route.params.id
    },
    supplierName() {
      return this.$route.query.name || ''
    },
    pageIndex() {
      return (this.currentPage - 1) * this.pageSize + 1
    }
  },
  mounted() {
    this.fetchKeys()
  },
  methods: {
    onPageChange(page) {
      this.currentPage = page
      this.fetchKeys()
    },
    onSearch() {
      this.currentPage = 1
      this.fetchKeys()
    },
    goBack() {
      this.$router.push('/suppliers')
    },
    async fetchKeys() {
      try {
        const res = await this.$http.get('/admin/suppliers/' + this.supplierId + '/api-keys', {
          params: {
            keyword: this.searchQuery || undefined,
            page: this.currentPage,
            pageSize: this.pageSize
          }
        })
        this.keys = res.records || []
        this.total = Number(res.total) || 0
      } catch {
        this.$message.error('加载 API Key 列表失败')
      }
    },
    onAdd() {
      this.dialogTitle = '新增 API Key'
      this.form = {
        id: null,
        name: '',
        apiKey: ''
      }
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.form?.clearValidate())
    },
    onEdit(row) {
      this.dialogTitle = '编辑 API Key'
      this.form = { id: row.id, name: row.name, apiKey: row.apiKey }
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.form?.clearValidate())
    },
    submitForm() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        this.submitting = true
        try {
          if (this.form.id) {
            await this.$http.put('/admin/suppliers/' + this.supplierId + '/api-keys/' + this.form.id, {
              name: this.form.name,
              apiKey: this.form.apiKey,
              status: '启用'
            })
            this.$message.success('编辑成功')
          } else {
            await this.$http.post('/admin/suppliers/' + this.supplierId + '/api-keys', {
              name: this.form.name,
              apiKey: this.form.apiKey,
              status: '启用'
            })
            this.$message.success('新增成功')
          }
          this.dialogVisible = false
          this.fetchKeys()
        } catch {
          this.$message.error('操作失败')
        } finally {
          this.submitting = false
        }
      })
    },
    async onToggleStatus(row) {
      const action = row.status === '启用' ? '禁用' : '启用'
      try {
        await this.$http.put('/admin/suppliers/' + this.supplierId + '/api-keys/' + row.id + '/toggle-status')
        this.$message.success(action + '成功')
        this.fetchKeys()
      } catch {
        this.$message.error('操作失败')
      }
    },
    onDelete(row) {
      this.$confirm('确定删除 Key「' + row.name + '」？', '确认删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        return this.$http.delete('/admin/suppliers/' + this.supplierId + '/api-keys/' + row.id)
      }).then(() => {
        this.$message.success('删除成功')
        this.fetchKeys()
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.supplier-api-keys-page {
  padding: 18px 24px 76px;
}

.table-panel {
  padding: 16px;
  border-radius: var(--radius);
  box-shadow: var(--shadow);
}

.table-panel ::v-deep .el-table,
.table-panel ::v-deep .el-table__header-wrapper,
.table-panel ::v-deep .el-table__body-wrapper {
  border-radius: var(--radius);
}

.table-panel ::v-deep th {
  background: rgba(255, 255, 255, 0.045);
  color: #9eb1ca;
  font-weight: 850;
}

.table-panel ::v-deep td,
.table-panel ::v-deep th {
  border-color: var(--line-soft);
}

.pagination-bar {
  margin-top: 20px;
  text-align: right;
}

.toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 18px;
  flex-wrap: wrap;
}

.search-input {
  width: 200px;
}

.key-text {
  font-size: 13px;
  color: #8eddf8;
  background: rgba(50, 200, 245, 0.1);
  padding: 2px 8px;
  border-radius: 4px;
}

.delete-btn {
  color: #ff93a4;
}

.delete-btn:hover {
  color: #ffb6c1;
}

.enable-btn {
  color: var(--cyan);
}

.list-cards {
  display: grid;
  gap: 14px;
}

.mobile-only { display: none; }

@media (max-width: 760px) {
  .desktop-only { display: none; }
  .mobile-only { display: block; }
  .supplier-api-keys-page {
    padding: 12px 12px 28px;
  }
  .table-panel {
    padding: 10px;
    overflow-x: visible;
  }
  .toolbar {
    flex-wrap: wrap;
  }
  .search-input {
    flex: 1;
    min-width: 80px;
  }
  .pagination-bar {
    text-align: center;
  }
}
/* Card redesign */
.list-card {
  padding: 16px;
  border-radius: 10px;
  background: linear-gradient(135deg, rgba(27,39,58,.92), rgba(20,30,46,.88));
  border: 1px solid rgba(133,164,255,.12);
  box-shadow: 0 8px 28px rgba(0,0,0,.22);
  overflow: hidden;
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
  gap: 8px;
}
.card-title {
  font-size: 15px;
  font-weight: 700;
  color: var(--text);
  line-height: 1.3;
}
.card-sub {
  font-size: 12px;
  color: rgba(255,255,255,.4);
  margin-top: 2px;
}
.meta-row {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 12px;
  padding-top: 10px;
  border-top: 1px solid rgba(133,164,255,0.06);
  margin-top: 6px;
  font-size: 11px;
  color: rgba(255,255,255,.35);
}
.card-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding-top: 10px;
  border-top: 1px solid rgba(133,164,255,0.06);
  margin-top: 6px;
}
.card-actions .el-button--text {
  font-size: 12px;
  padding: 4px 10px;
  height: auto;
}
</style>
